module.exports = __webpack_public_path__ + "static/media/about01.821bcd2b.png";